<template>
    <div class="soMeLoginButtons" id="soMeLoginButtonsId" ref="refsoMeLoginButtons">
        
    <facebookLoginButton></facebookLoginButton>
    <googleLoginButton></googleLoginButton>
    <!-- Redirect method -->
</div>
</template>

<script>
import ResizeObserver from 'resize-observer-polyfill';
import facebookLoginButton from './components/facebookLoginButton.vue'
import googleLoginButton from './components/googleLoginButton.vue';

export default {
    name: "soMeLoginButtons",
    components: {
        // GoogleLogin
        facebookLoginButton,
        googleLoginButton,
        // facebookLoginBtnv2
    },
    data() {
        return {
            // Mutation Observer
            width: null,
            height: null,
            observer: null,
            // DATA VARIABLES
            windowLocOrign: '',
            baseDir: '',
        }
    },
    mounted(){
        //console.log(`//// ${this.$options.name} Mounted ////`);

        this.windowLocOrign = window.location.origin;
        this.baseDir = basedir;
    },
    methods: {

    },
    computed:{
       
    },
    beforeDestroy() {
        this.destroyObserver(this.$refs.refGoogleLoginButton);
    },
};
</script>

<style lang="scss">

.googleLoginButton *{
   // all:unset;
}
.soMeLoginButtons{
    width:100%;
    display: flex; 
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

</style>